import { Badge } from '@/components/base/badge'
import { Field, Label } from '@/components/base/fieldset'
import { Input } from '@/components/base/input'
import { Select } from '@/components/base/select'
import type { ItemTypeDetailFragment } from '@/gql/graphql'
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react'

type CapacitanceNode = Node<{ name: string, connectorFamilies: ItemTypeDetailFragment['connectorFamilies'], connectorFamilyPinA: { id: string }, connectorFamilyPinB: { id: string } }, 'capacitance'>

export const CapacitanceNode = ({ data }: NodeProps<CapacitanceNode>) => {
  const connectorFamilyPinOptions = data.connectorFamilies.reduce((acc, connectorFamily) => {
    connectorFamily.connectorFamilyPins.forEach(pin => {
      acc[pin.id] = { value: pin.id, label: `${connectorFamily.name} - ${pin.name}`, detail: pin.role }
    })
    return acc
  }, {} as { [id: string]: { value: string, label: string, detail: string } })

  return (
    <div>
      <div className="text-white border border-zinc-500 rounded-lg p-4 bg-zinc-800/75 w-100">
        <div className="grid grid-cols-2 gap-2 items-center justify-around h-full">
          <div className="col-span-2 text-center"><Badge color="green">Capacitance</Badge></div>
          <Field className="col-span-2">
            <Label>Name</Label>
            <Input value={ data.name } />
          </Field>
          <Field>
            <Label>Connector pin A</Label>
            <Select>
              { Object.values(connectorFamilyPinOptions).map(option => <option selected={ data.connectorFamilyPinA.id === option.value } value={ option.value }>{ option.label }</option>) }
            </Select>
          </Field>
          <Field>
            <Label>Connector pin B</Label>
            <Select>
              { Object.values(connectorFamilyPinOptions).map(option => <option selected={ data.connectorFamilyPinB.id === option.value } value={ option.value }>{ option.label }</option>) }
            </Select>
          </Field>
        </div>
      </div>
      <Handle position={ Position.Top } type="source" />
      <Handle position={ Position.Bottom } type="target" />
    </div>
  )
}
